import React, { useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

import "./assets/css/tailwind.css";
import "./assets/css/icons.css";

// Eager load the home page for fastest initial render
import Index from "./pages/index.js";
import ScrollToTop from "./component/Scroll-top.js";

// Lazy load all other routes for code splitting
const PropertyDetail = lazy(() => import("./pages/property-detail.js"));
const Buy = lazy(() => import("./pages/buy.js"));
const Sell = lazy(() => import("./pages/sell.js"));
const Aboutus = lazy(() => import("./pages/aboutus.js"));
const Features = lazy(() => import("./pages/features.js"));
const Pricing = lazy(() => import("./pages/pricing.js"));
const Login = lazy(() => import("./pages/auth/login.js"));
const Signup = lazy(() => import("./pages/auth/signup.js"));
const ResetPassword = lazy(() => import("./pages/auth/reset-password.js"));
const Comingsoon = lazy(() => import("./pages/comingsoon.js"));
const Maintenance = lazy(() => import("./pages/maintenance.js"));
const Page404 = lazy(() => import("./pages/404.js"));
const Terms = lazy(() => import("./pages/terms.js"));
const Privacy = lazy(() => import("./pages/privacy.js"));
const Contact = lazy(() => import("./pages/contact.js"));
const Grid = lazy(() => import("./pages/grid.js"));
const GridSidebar = lazy(() => import("./pages/grid-sidebar.js"));
const GridMap = lazy(() => import("./pages/grid-map.js"));
const List = lazy(() => import("./pages/list.js"));
const ListMap = lazy(() => import("./pages/list-map.js"));
const ListSidebar = lazy(() => import("./pages/list-sidebar.js"));
const BlogDetail = lazy(() => import("./pages/blog-detail.js"));
const Blogs = lazy(() => import("./pages/blogs.js"));
const BlogSidebar = lazy(() => import("./pages/blog-sidebar.js"));
const Faq = lazy(() => import("./pages/faq.js"));
const IndexEight = Index;
const PropertyDetailTwo = lazy(() => import("./pages/property-detail-two.js"));
const Agents = lazy(() => import("./pages/agents.js"));
const AgentProfile = lazy(() => import("./pages/agent-profile.js"));
const Agencies = lazy(() => import("./pages/agencies.js"));
const AgencyProfile = lazy(() => import("./pages/agency-profile.js"));
const Highlands = lazy(() => import("./pages/highlands.js"));

// Loading fallback component
const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      fontSize: "18px",
      color: "#666",
    }}
  >
    Loading...
  </div>
);

function App() {
  useEffect(() => {
    document.documentElement.setAttribute("dir", "ltr");
    document.documentElement.classList.add("light");
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/index" element={<Index />} />
          <Route path="/index-eight" element={<IndexEight />} />
          <Route path="/property-detail/:id" element={<PropertyDetail />} />
          <Route
            path="/property-detail-two/:id"
            element={<PropertyDetailTwo />}
          />
          <Route path="/buy" element={<Buy />} />
          <Route path="/sell" element={<Sell />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/auth-login" element={<Login />} />
          <Route path="/auth-signup" element={<Signup />} />
          <Route path="/auth-reset-password" element={<ResetPassword />} />
          <Route path="/comingsoon" element={<Comingsoon />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/grid" element={<Grid />} />
          <Route path="/grid-sidebar" element={<GridSidebar />} />
          <Route path="/grid-map" element={<GridMap />} />

          <Route path="/list" element={<List />} />
          <Route path="/list-sidebar" element={<ListSidebar />} />
          <Route path="/list-map" element={<ListMap />} />

          <Route path="/404" element={<Page404 />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<Faq />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog-detail" element={<BlogDetail />} />
          <Route path="/blog-detail/:id" element={<BlogDetail />} />
          <Route path="/blog-sidebar" element={<BlogSidebar />} />

          <Route path="/agents" element={<Agents />} />
          <Route path="/agent-profile" element={<AgentProfile />} />
          <Route path="/agent-profile/:id" element={<AgentProfile />} />

          <Route path="/agencies" element={<Agencies />} />
          <Route path="/agency-profile" element={<AgencyProfile />} />
          <Route path="/agency-profile/:id" element={<AgencyProfile />} />

          <Route path="/highlands" element={<Highlands />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
export default App;
